import $ from 'jquery';

global.$ = $;
global.jQuery = $;
global.jquery = $;

import {Popover, Collapse, Dropdown, Modal} from 'bootstrap';
import 'formvalidation';
import 'formvalidation/dist/js/framework/bootstrap';
import 'leaflet';
import 'leaflet-providers';

require('leaflet.markercluster');

import LazyLoadManager from "../../services/lazyLoadManager";

import scrollAffixManager from "../../services/scrollAffixManager.js";
import HotelReviewManager from "../../services/hotelReview/hotelReviewManager";
import SearcherManager from "../../services/search/searcherManager";
import ChollosFilterer from "../../services/filterer/chollos/chollosFilterer";
import MyAppConfig from "../../myApp.config";
import BrowserStorageService from "../../services/browserStorageService";
import UserManager from "../../services/userManager";
import DeviceDetector from "../../services/deviceDetector";
import UrlManager from "../../services/urlManager";
import ScrollManager from "../../services/scrollManager";
import DomAnimator from "../../services/domAnimator";
import TextTransformer from "../../services/dom/utilities/textTransformer";
import CollapseManager from "../../services/dom/utilities/collapseManager";
import PopoverManager from "../../services/dom/utilities/popoverManager";
import DateFormatter from "../../services/dateFormatter";
import DomManager from "../../services/dom/domManager";
import TranslatorService from "../../services/translator/translatorService";
import AffixManager from "../../services/affixManager";
import FormObserver from "../../services/forms/formObserver";
import FormPrinter from "../../services/forms/formPrinter";
import FormValidator from "../../services/forms/formValidator";
import FormGroupValidator from "../../services/forms/formGroupValidator";
import FormSubmitterManager from "../../services/forms/formSubmitter";
import NewsletterSubscriptionValidator from "../../services/forms/validator/newsletterSubscriptionValidator";
import SendBudgetFormValidator from "../../services/forms/validator/book/sendBudgetFormValidator";
import DropdownManager from "../../services/dom/utilities/dropdownManager";
import SubscribeManager from "../../services/subscribeManager";
import BrowserHistoryManager from "@web/vpt-assets/assets/js/utilities/dom/browserHistoryManager";
import EmailCleaner from "../../services/forms/emailCleaner";
import Lightbox from "../../services/lightbox/lightbox";
import MenuManager from "../../services/menu/menuManager";
import SearchSuggest from "../../services/search/searchSuggest";
import CopyTextManager from "../../util/copyTextManager";
import HotelCustomMapBuilder from "../../services/customMap/hotelCustomMapBuilder";
import ReviewsManager from "../../services/reviewsManager";
import HotelManager from "../../services/hotel/hotelManager";
import webComponentsHotelCard from "@web/web-components/componentsHotelCard.js";
import ServicesController from "@web/vpt-assets/assets/js/controller/servicesController";
import CollapseManagerNew from "@web/vpt-assets/assets/js/utilities/collapseManager";
import CustomModalManager from "@web/vpt-assets/assets/js/utilities/customModalManager";
import CustomDropdownManager from "@web/vpt-assets/assets/js/utilities/dropdownManager";
import UserLoginRegisterModalHandler
    from "@web/vpt-assets/assets/js/modules/userLoginRegister/userLoginRegisterModalHandler";
import InfoActiveAccountHandler from "@web/vpt-assets/assets/js/modules/userLoginRegister/infoActiveAccountHandler";
import TrackersManager from "../../services/trackers/trackersManager";
import GroupThematicReviewManager from "../../services/group/groupThematicReviewManager";
import SliderManager from "../../services/slider/sliderManager";
import * as Swiper from 'swiper';
import InteractionCookieSetter from "@web/vpt-assets/assets/js/utilities/interaction/interactionCookieSetter";
import * as Sentry from "@sentry/browser";
import ModalManager from "@web/web-components/js/components/modalManager";
import CustomSlider from "@web/web-components/custom-slider/src/customSlider";
import GalleryManager from "@web/vpt-assets/assets/js/modules/gallery/galleryManager";
import SliderManagerWebComponents from "@web/web-components/js/components/sliderManager";

global.myApp = {
    initializer: {},
    form: {
        book: {},
        validator: {},
        dataTransformer: {}
    },
    controller: {
        subscribeController: {},
        step1Controller: {},
        step2Controller: {},
        step3Controller: {}
    },
    translator: {},
    mapBuilder: {},
    book: {},
    user: {},
    menu: {},
    filterer: {},
    components: {
        time: {}
    },
    tracking: {
        gtm: {},
        ga: {}
    },
    lightboxList: [],
    config: []
};

$(function () {
    myApp.myAppConfig = new MyAppConfig();
    myApp.config.rootPath = myApp.myAppConfig.rootPath;
    myApp.config.cdnPath = myApp.myAppConfig.cdnPath;
    myApp.config.analytics = myApp.myAppConfig.analytics;
    myApp.browserStorageService = new BrowserStorageService();
    myApp.userManager = new UserManager();
    myApp.deviceDetector = new DeviceDetector();
    myApp.urlManager = new UrlManager();
    myApp.scrollManager = new ScrollManager();
    myApp.domAnimator = new DomAnimator();
    myApp.textTransformer = new TextTransformer();
    myApp.collapseManager = new CollapseManager();
    myApp.popoverManager = new PopoverManager();
    myApp.reviewsManager = new ReviewsManager();
    myApp.dateFormatter = new DateFormatter();
    myApp.domManager = new DomManager();
    myApp.translatorService = new TranslatorService();
    myApp.affixManager = new AffixManager();
    myApp.form.observer = new FormObserver();
    myApp.form.formPrinter = new FormPrinter();
    myApp.formValidator = new FormValidator();
    myApp.formGroupValidator = new FormGroupValidator();
    myApp.formSubmitterManager = new FormSubmitterManager();
    myApp.form.validator.newsletterSubscriptionValidator = new NewsletterSubscriptionValidator();
    myApp.form.validator.sendBudgetFormValidator = new SendBudgetFormValidator();
    myApp.dropdownManager = new DropdownManager();
    myApp.subscribeManager = new SubscribeManager();
    const servicesController = new ServicesController();
    myApp.customModalManager = servicesController.getService(CustomModalManager.className, {'closeImmediately': myApp.config.parameters.isIOSApp});
    myApp.browserHistoryManager = servicesController.getService(BrowserHistoryManager.className);
    myApp.form.dataTransformer.EmailCleaner = new EmailCleaner();
    myApp.lightbox = new Lightbox();
    myApp.menu.manager = new MenuManager();
    myApp.chollosFilterer = new ChollosFilterer();
    myApp.collapseManagerNew = new CollapseManagerNew();
    myApp.user.loginManager = new UserLoginRegisterModalHandler();

    new InfoActiveAccountHandler({
        isUserLoggedIn: myApp.config.isUserLoggedIn,
        isActivateAccount: activateAccountInfo['userActivate']
    });
    new scrollAffixManager();
    myApp.groupThematicReviewManager = new GroupThematicReviewManager();
    new HotelReviewManager();
    new SearcherManager();
    new SearchSuggest();
    new CopyTextManager();
    new HotelManager();
    new TrackersManager();
    new InteractionCookieSetter(Sentry.captureException.bind(Sentry));
    myApp.customDropdownManagerNew = new CustomDropdownManager();
    const sliderManager = new SliderManager();
    sliderManager.addSlider('[data-entity="reviews-with-photos"] [data-entity="slider"]', null, null);

    const modalManager = new ModalManager();
    const customSlider = new CustomSlider();
    new GalleryManager(modalManager, customSlider, SliderManagerWebComponents, Swiper, myApp.deviceDetector.isXsScreen());

    $(document).ready(function () {
        myApp.hotelCustomMapBuilder = new HotelCustomMapBuilder();
        let urlParams = new URLSearchParams(document.location.search);
        if (urlParams.has('id_survey')) {
            let headerHeight = document.querySelector('[data-entity="mobile-navbar-menu"]').offsetHeight;
            let offset = (myApp.deviceDetector.isXsScreen() || myApp.deviceDetector.isSmScreen() ? headerHeight : 0) + 10;
            window.scrollTo({
                top: window.scrollY + document.querySelector('[data-reviews-container]').getBoundingClientRect().top - offset,
                behavior: 'smooth',
            })
        }
    });

    document.querySelectorAll('image-gallery-list').forEach((element) => {
        element.initializeSwiper(Swiper);
    });

    document.querySelectorAll('user-review').forEach((element) => {
        element.setSwiper(Swiper);
    });
});
